import { GridItem } from "@libertify/ui/components/Grid/Grid";
import type { GridSpan } from "@libertify/ui/components/Grid/Grid";
import { FormLabel } from "./FormLabel";
import { Form } from "antd";
import type { FormItemProps } from "antd";
import { useTranslate } from "@refinedev/core";

interface PlaybookFormItemProps {
  name: string | (string | number)[];
  labelKey: string;
  /** Which prop on the child carries the value. Pass "checked" for
   *  Toggle/Switch fields; defaults to antd's "value" for inputs/selects. */
  valuePropName?: string;
  /** antd pass-through: maps the STORED (API-unit) value to the child's props.
   *  Pair with `normalize` when the displayed unit differs from the stored one
   *  (fraction rendered as a percent input, order enum rendered as a toggle). */
  getValueProps?: (value: unknown) => Record<string, unknown>;
  /** antd pass-through: maps the child's output back to the STORED value. */
  normalize?: (value: unknown) => unknown;
  /** antd pass-through: validation rules. Also drives the required marker. */
  rules?: FormItemProps["rules"];
  /** Columns the field spans in its parent Grid. Defaults to 1 (half of a
   *  two-column grid); pass the column count for a full-width field. */
  span?: GridSpan;
  children: React.ReactNode;
}

export const PlaybookFormItem = ({
  name,
  labelKey,
  valuePropName,
  getValueProps,
  normalize,
  rules,
  span,
  children,
}: PlaybookFormItemProps) => {
  const t = useTranslate();
  return (
    <GridItem span={span}>
      <Form.Item
        label={<FormLabel label={t(labelKey)} />}
        name={name}
        valuePropName={valuePropName}
        getValueProps={getValueProps}
        normalize={normalize}
        rules={rules}
      >
        {children}
      </Form.Item>
    </GridItem>
  );
};
